// extracted by mini-css-extract-plugin
export default {"app":"App_app__m0X6l","content":"App_content__52TDD","menu":"App_menu__uXSGr","active":"App_active__u1Llm","priceFont":"App_priceFont__U0AAp","bottomMenu":"App_bottomMenu__OF8o3"};